import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { strings } from '../common/translations';
import {
    Container, Header, Grid
} from 'semantic-ui-react';
import Particles from 'react-particles-js';
import { FiExternalLink } from 'react-icons/fi';

class SectionSPARQL extends Component {
    constructor(props) {
        super(props)
        this.refTop = React.createRef();
    }
    render() {
        return (
            <Container fluid className="section section-sparql h-100">
                <div className="chart-list bg-animation h-100" ref={this.refTop}>
                <Particles className="position-absolute w-100 h-100" />
                <Grid columns={2}>
                    <Grid.Row>
                        <Grid.Column width={5}>
                            <Header as="h1" className="section_title">{strings.SPARQL.TITLE}</Header>
                            <p className="section_description">
                                {/* <FiExternalLink /> <span dangerouslySetInnerHTML={{ __html:strings.SPARQL.INTRO_LINK1}} /><br></br> */}
                                <FiExternalLink /> <span><a href={strings.SPARQL.INTRO_LINK1 + "?" + process.env.REACT_APP_API_ENDPOINT} target="_blank" rel="noopener noreferrer" className="text-white">{strings.SPARQL.INTRO_LINK1_TEXT}</a></span><br></br>
                                <FiExternalLink /> <span dangerouslySetInnerHTML={{ __html:strings.SPARQL.INTRO_LINK2}} /><br></br>
                                <FiExternalLink /> <span><a className="text-white"  href={strings.COMMON.MANUAL_EXTENDED_URL} target="_blank" rel="noopener noreferrer">{strings.COMMON.MANUAL_EXTENDED}</a></span>
                            </p>
                            <p className="section_description">
                                <FiExternalLink /> <span><a className="text-white" href={strings.COMMON.MANUAL_URL} target="_blank" rel="noopener noreferrer">{strings.COMMON.MANUAL}</a></span>
                            </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                            <div className="box py-3 px-4" dangerouslySetInnerHTML={{ __html: strings.SPARQL.DESCRIPTION }} />
                            <div className="box">
                                <ReactPlayer width='100%' controls={true} url={['videos/sparql.mov']} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                </div>
            </Container>
        );
    }
}

export default SectionSPARQL;